export enum ModifierTypes {
  EXPERIENCE_MODIFICATION = 'EXPERIENCE_MODIFICATION',
  ASSOCIATION_CREDIT = 'ASSOCIATION_CREDIT',
  IRPM = 'IRPM',
  ADMIN_FEE = 'ADMIN_FEE',
  BROKER_FEE = 'BROKER_FEE',
  COMMISSION = 'COMMISSION',
  SCHEDULED_RATING = 'SCHEDULE_RATING',
  LOCAL_TAX = 'local_tax',
  INSURANCE_PREMIUM_SURCHARGE = 'insurance_premium_surcharge',
  COLLECTION_FEE = 'collection_fee',
  RENEWAL_RATING_FACTOR = 'RENEWAL_RATING_FACTOR',
  CORRECTION_FACTOR = 'CORRECTION_FACTOR',
}

export function isScheduleRating(key: string): boolean {
  return key?.toUpperCase() === 'SCHEDULE_RATING';
}
